import { StepLayout } from 'components/StepLayout/StepLayout';
import { useStoreSetup } from 'hooks/useStoreSetup';
import React, { FC, useCallback } from 'react';
import { StoreSetupStepProgress } from './components/StoreSetupStepProgress';
import { useTranslation } from '@wix/wix-i18n-config';
import { useOrchestratorNavigation } from '@wix/gg-components/orchestrator';
import { StoreSetupStepError } from './components/StoreSetupStepError';

export const StoreSetupStep: FC = () => {
  const { t } = useTranslation();
  const { isSuccess, isError, refetch } = useStoreSetup();
  const { next } = useOrchestratorNavigation();

  const renderContent = useCallback(() => {
    if (isError) {
      return <StoreSetupStepError onTryAgain={refetch} />;
    }

    return <StoreSetupStepProgress shouldComplete={isSuccess} onComplete={next} />;
  }, [isError, isSuccess, refetch, next]);

  return (
    <StepLayout
      hideActions
      description={t('store-setup-step.progress.description')}
      title={t('store-setup-step.progress.title')}
    >
      {renderContent()}
    </StepLayout>
  );
};
